import { render, staticRenderFns } from "./SettlementHistories.vue?vue&type=template&id=4580632a"
import script from "./SettlementHistories.vue?vue&type=script&lang=js"
export * from "./SettlementHistories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports